// @flow
import { combineReducers } from 'redux';

import articleReducer from 'reducers/articleReducer';
import articlesReducer from 'reducers/articlesReducer';
import appReducer from 'reducers/appReducer';
import eventsPreviewReducer from 'reducers/eventsPreviewReducer';
import tagsReducer from 'reducers/tagsReducer';
import instagramReducer from 'reducers/instagramReducer';
import twitterReducer from 'reducers/twitterReducer';
import facebookReducer from 'reducers/facebookReducer';
import newsletterReducer from 'reducers/newsletterReducer';
import menuReducer from 'reducers/menuReducer';
import eventReducer from 'reducers/eventReducer';
import filterOptionsReducer from 'reducers/filterOptionsReducer';
import categoriesReducer from 'reducers/categoriesReducer';
import newsletterCategoryReducer from 'reducers/newsletterCategoryReducer';
import eventsReducer from 'reducers/eventsReducer';
import partnersReducer from 'reducers/partnersReducer';
import settingsReducer from 'reducers/settingsReducer';
import cardReducer from 'reducers/cardReducer';
import pageListReducer from 'reducers/pageListReducer';
import pageNodeReducer from 'reducers/pageNodeReducer';
import pageDetailReducer from 'reducers/pageDetailReducer';
import pageDetailPreviewReducer from 'reducers/pageDetailPreviewReducer';
import sidebarReducer from 'reducers/sidebarReducer';
import faqReducer from 'reducers/faqReducer';
import searchReducer from 'reducers/searchReducer';
import newsletterSubscriptionReducer from 'reducers/newsletterSubscriptionReducer';
import modalReducer from 'reducers/modalReducer';
import youtubeReducer from 'reducers/youtubeReducer';
import seasonsReducer from 'reducers/seasonsReducer';
import rencontreReducer from 'reducers/rencontreReducer';
import rencontreLiveReducer from 'reducers/rencontreLiveReducer';
import rankingReducer from 'reducers/team/rankingReducer';
import teamResultReducer from 'reducers/team/teamResultReducer';
import teamCalendarReducer from 'reducers/team/teamCalendarReducer';
import AlbumReducer from 'reducers/AlbumReducer';
import PartenaireReducer from 'reducers/PartenaireReducer';
import mediaReducer from 'reducers/mediaReducer';
import tagArticleReducer from './tagArticleReducer';
import teamPlayerReducer from './team/teamPlayerReducer';
import contactForm7Reducer from 'reducers/contactForm7Reducer';
import userReducer from 'reducers/userReducer';
import homeReducer from 'reducers/homeReducer';

export default (combineReducers({
  articleState: articleReducer,
  articlesState: articlesReducer,
  appState: appReducer,
  eventsPreviewState: eventsPreviewReducer,
  tagsState: tagsReducer,
  instagramState: instagramReducer,
  facebookState: facebookReducer,
  twitterState: twitterReducer,
  newsletterState: newsletterReducer,
  menuState: menuReducer,
  eventState: eventReducer,
  filterOptionsState: filterOptionsReducer,
  categoriesState: categoriesReducer,
  newsletterCategoryState: newsletterCategoryReducer,
  eventsState: eventsReducer,
  partnersState: partnersReducer,
  settingsState: settingsReducer,
  cardState: cardReducer,
  pageListState: pageListReducer,
  pageNodeState: pageNodeReducer,
  pageDetailState: pageDetailReducer,
  pageDetailPreviewState: pageDetailPreviewReducer,
  sidebarState: sidebarReducer,
  faqState: faqReducer,
  searchState: searchReducer,
  newsletterSubscriptionState: newsletterSubscriptionReducer,
  modalState: modalReducer,
  youtubeState: youtubeReducer,
  seasonsState: seasonsReducer,
  rencontreState: rencontreReducer,
  rencontreLiveState: rencontreLiveReducer,
  rankingState: rankingReducer,
  teamResultState: teamResultReducer,
  teamCalendarState: teamCalendarReducer,
  albumState: AlbumReducer,
  partenaireState: PartenaireReducer,
  mediaState: mediaReducer,
  tagArticleState: tagArticleReducer,
  teamPlayerState: teamPlayerReducer,
  contactForm7State: contactForm7Reducer,
  userState: userReducer,
  homeState: homeReducer
}): any);
